import Badge from '../components/Badge';

export const slotStatusColors: { [key: string]: { bg: string; text: string } } =
  {
    DISCARDED: { bg: '#FFCDD2', text: '#B71C1C' },
    UNAVAILABLE: { bg: '#fdecea', text: '#d93025' },
    AVAILABLE: { bg: '#C8E6C9', text: '#2E7D32' },
  };

export const slotStatusTranslation: { [key: string]: string } = {
  DISCARDED: 'DESCARTADO',
  UNAVAILABLE: 'NO DISPONIBLE',
  AVAILABLE: 'DISPONIBLE',
};

const getColorProps = (colors: any, value: string) => ({
  backgroundColor: colors[value].bg,
  ballColor: colors[value].text,
});

const renderSlotStatus = (status: string) => {
  if (!status) return <>Desconocido</>;
  const colorProps = getColorProps(slotStatusColors, status);
  return (
    <div style={{ width: 'fit-content' }}>
      <Badge {...colorProps} value={slotStatusTranslation[status]} />
    </div>
  );
};

export default renderSlotStatus;
